import { useEffect, useState } from "react";
import { useScoreApi, unwrap } from "../api/scoreApi";

const EMPTY = new Map();

// #3651 -- every class of the show with a Placing problem, from the generated
// client's getShowPlaceProblems (GET /show/:showId/place-problems, #3650).
// -> Map classId -> the server row (reason, blockingRides, manualRides,
// tiedRides, classNumber...), which is already the preview shape
// placeByRulesProblems and PlaceByRulesProblems read.
//
// `refreshKey` is BadgeCountsContext's loadedTick, so this re-reads exactly when
// the badge counts do (same change check, same backstop, same mutation
// refresh) and runs no poll of its own. A failed read keeps the last good list:
// a blip must not empty the filter.
//
// #3670 -- returns { byClassId, loaded }. `loaded` is false until a read has
// answered OK once (for this show), so the caller never prints a count it could
// not read as 0. A failed read leaves `loaded` as it was.
export default function usePlaceProblems(showId, refreshKey = 0) {
  const scoreApi = useScoreApi();
  const [byClassId, setByClassId] = useState(EMPTY);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setByClassId(EMPTY);
    setLoaded(false);
  }, [showId]);

  useEffect(() => {
    if (!showId) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const data = unwrap(await scoreApi.shows.getShowPlaceProblems(showId));
        if (cancelled) return;
        setByClassId(new Map((data?.placeProblems ?? []).map((row) => [row.classId, row])));
        setLoaded(true);
      } catch {
        /* keep the last good list */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [scoreApi, showId, refreshKey]);

  return { byClassId, loaded };
}
